import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Dimensions } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigation } from '@react-navigation/native';

const { width } = Dimensions.get('window');

const HelpCenterScreen = () => {
    const { colors } = useTheme();
    const navigation = useNavigation();
    const isMobile = width < 768;

    const helpCategories = [
        {
            id: 'calculators',
            title: 'Calculators Help',
            description: 'Learn how to use our financial calculators effectively',
            icon: 'calculator',
            items: ['How to use EMI Calculator', 'Understanding SIP calculations', 'Tax calculator guide']
        },
        {
            id: 'tools',
            title: 'Tools Support',
            description: 'Get help with Invoice Generator and Quotation Maker',
            icon: 'construct',
            items: ['Creating your first invoice', 'Adding GST to invoices', 'Exporting quotations']
        },
        {
            id: 'account',
            title: 'Account & Profile',
            description: 'Manage your account settings and profile',
            icon: 'person',
            items: ['How to update profile', 'Password reset', 'Account security']
        },
        {
            id: 'services',
            title: 'Our Services',
            description: 'Information about GST, ITR, and other services',
            icon: 'briefcase',
            items: ['GST Filing process', 'ITR Filing requirements', 'Business registration']
        },
    ];

    const styles = StyleSheet.create({
        container: { flex: 1, backgroundColor: colors.background },
        scrollView: { flex: 1 },
        hero: {
            backgroundColor: '#1a1a4e',
            paddingVertical: 60,
            paddingHorizontal: 20,
            alignItems: 'center',
        },
        heroTitle: {
            fontSize: isMobile ? 28 : 40,
            fontWeight: '800',
            color: '#c9a44e',
            textAlign: 'center',
            marginBottom: 12,
        },
        heroSubtitle: {
            fontSize: 16,
            color: 'rgba(255,255,255,0.8)',
            textAlign: 'center',
            maxWidth: 600,
        },
        content: {
            padding: 20,
            maxWidth: 1100,
            alignSelf: 'center',
            width: '100%',
        },
        sectionTitle: {
            fontSize: 24,
            fontWeight: '700',
            color: colors.text,
            marginBottom: 20,
            textAlign: 'center',
        },
        grid: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 20,
        },
        card: {
            backgroundColor: colors.surface,
            borderRadius: 12,
            padding: 24,
            width: isMobile ? '100%' : '45%',
            borderWidth: 1,
            borderColor: colors.border,
        },
        cardIcon: {
            width: 56,
            height: 56,
            borderRadius: 28,
            backgroundColor: '#1a1a4e',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 16,
        },
        cardTitle: {
            fontSize: 18,
            fontWeight: '700',
            color: colors.text,
            marginBottom: 8,
        },
        cardDescription: {
            fontSize: 14,
            color: colors.textSecondary,
            marginBottom: 16,
        },
        cardItem: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: 6,
        },
        cardItemText: {
            fontSize: 14,
            color: colors.primary,
            marginLeft: 8,
        },
        contactSection: {
            backgroundColor: colors.surface,
            padding: 30,
            borderRadius: 12,
            marginTop: 40,
            alignItems: 'center',
            borderWidth: 1,
            borderColor: colors.border,
        },
        contactTitle: {
            fontSize: 20,
            fontWeight: '700',
            color: colors.text,
            marginBottom: 12,
        },
        contactText: {
            fontSize: 14,
            color: colors.textSecondary,
            textAlign: 'center',
            marginBottom: 20,
        },
        contactButton: {
            backgroundColor: '#c9a44e',
            paddingVertical: 14,
            paddingHorizontal: 28,
            borderRadius: 8,
        },
        contactButtonText: {
            color: '#1a1a4e',
            fontWeight: '700',
            fontSize: 15,
        },
    });

    return (
        <View style={styles.container}>
            <Header />
            <ScrollView style={styles.scrollView}>
                <View style={styles.hero}>
                    <Text style={styles.heroTitle}>Help Center</Text>
                    <Text style={styles.heroSubtitle}>
                        Find answers to your questions and learn how to make the most of Modern Munshiji
                    </Text>
                </View>

                <View style={styles.content}>
                    <Text style={styles.sectionTitle}>Browse Help Topics</Text>
                    <View style={styles.grid}>
                        {helpCategories.map((category) => (
                            <View key={category.id} style={styles.card}>
                                <View style={styles.cardIcon}>
                                    <Ionicons name={category.icon} size={24} color="#c9a44e" />
                                </View>
                                <Text style={styles.cardTitle}>{category.title}</Text>
                                <Text style={styles.cardDescription}>{category.description}</Text>
                                {category.items.map((item, index) => (
                                    <View key={index} style={styles.cardItem}>
                                        <Ionicons name="chevron-forward" size={14} color={colors.primary} />
                                        <Text style={styles.cardItemText}>{item}</Text>
                                    </View>
                                ))}
                            </View>
                        ))}
                    </View>

                    <View style={styles.contactSection}>
                        <Text style={styles.contactTitle}>Still need help?</Text>
                        <Text style={styles.contactText}>
                            Our support team is ready to assist you with any questions or concerns.
                        </Text>
                        <TouchableOpacity style={styles.contactButton} onPress={() => navigation.navigate('Contact')}>
                            <Text style={styles.contactButtonText}>Contact Support</Text>
                        </TouchableOpacity>
                    </View>
                </View>

                <Footer />
            </ScrollView>
        </View>
    );
};

export default HelpCenterScreen;
